export default {"src":"/_next/static/media/oxt.e52fbb7e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};